<template>
  <router-link
    to="/dashboard"
    class="sidebar-logo"
    :class="{ minimized: minimized }"
  >
    <logo-icon :minimized="minimized"/>
  </router-link>
</template>

<script>
import LogoIcon from './icons/LogoIcon'

export default {
  components: {
    LogoIcon,
  },
  computed: {
    minimized() {
      return this.$parent.minimized;
    }
  }
}
</script>

<style lang="scss" scoped>

.sidebar-logo {
  width: 100%;
  height: auto;
  padding: 10px;
  transition: padding .3s ease;
  border-bottom: 1px solid #E4E5E6;
  direction: ltr;
  display: flex;
  flex-direction: row;
  align-items: center;

  &.minimized {
    padding: 10px;
    .logo-text {
      transform: scale(0);
    }
    .logo-container {

    }
  }
}

</style>
